import { useSearchParams } from "react-router-dom";

export function FailPage() {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("orderNumber");
  const msg = searchParams.get("msg");

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>❌ 결제 실패</h1>
      <p>주문 번호: <strong>{orderNumber}</strong></p>
      <p>사유: {msg || '알 수 없는 오류'}</p>
      <a href="/spaces" style={{ marginTop: "1rem", display: "inline-block", color: "#EF4444" }}>
        홈 으로 이동
      </a>
    </div>
  );
}
